import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import FlatButton from '../buttons/FlatButton';
import DialogHeader from '../DialogHeader';
import Overview from '../common/ShippingCostOverview';

class ShippingCostDialog extends Component {

    state = {
        open: false,
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    render() {
        return (
            <div >
                <FlatButton
                    onClick={this.handleClickOpen}
                    text={this.props.label}
                />
                <Dialog
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                >
                    <DialogHeader
                        title={this.props.label}
                        onClose={this.handleRequestClose}
                    />
                    <DialogContent className='stolo-text' >
                        {this.props.header}
                        <Overview />
                    </DialogContent >
                    <DialogActions >
                        <FlatButton
                            onClick={this.handleRequestClose}
                            text={this.props.close}
                        />
                    </DialogActions >
                </Dialog >
            </div >
        );
    }

}

export default ShippingCostDialog;



// WEBPACK FOOTER //
// ./src/components/addtocart/ShippingCostDialog.js